<ngx-spinner bdColor="rgba(0, 0, 0, 0.4)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>

<div class="header-container">
  <!-- Row 1: Contributor Name -->
  <div class="contributor-box mt-2 mb-2">
    <h4 class="detail">Name: <strong>{{ user?.fullName }} </strong> - Business Unit: <strong>{{ user?.businessUnitName
        }} </strong></h4>
  </div>

  <div class="d-flex justify-content-center" *ngIf="!hideDiv">
    <h2 class="section-header">Commission Rate Plan</h2>
  </div>
</div>

<div  mat-align-tabs="start" class="p-4 pill-tabs background-color"
  *ngIf="userRoleRights?.includes('ViewConfigurationContributors') || userRoleRights?.includes('ViewMyCommissions'); else noAccess">
  <ng-template mat-tab-label>
    <span class="tab-label"> Commision Rate Plan</span>
  </ng-template>

  <div class="background-color mt-4">
      <button mat-raised-button class="btn-add"
        *ngIf="!hideDiv && userRoleRights?.includes('AddCommissionPlansConfigurationContributors')"
        (click)="openAddIncentiveProgramDialog()">
      <mat-icon>add</mat-icon>
      Add Commision Rate Plan
    </button>

    <div class="table-container mt-2">
      <table mat-table [dataSource]="dataSource" matSort>
        
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell" mat-sort-header>
            Name
          </th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="contributionPeriodName">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell" mat-sort-header>
            Contribution Period
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.contributionPeriodName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="effectiveDate">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell" mat-sort-header>
            Effective Date
          </th>
            <td mat-cell *matCellDef="let element">{{ element.effectiveDate }}</td>
        </ng-container>

        <ng-container matColumnDef="isPendingApprovalExists">
          <th mat-header-cell *matHeaderCellDef class="mat-header-cell">
            Pending Approval
          </th>
          <td mat-cell *matCellDef="let element">{{ hasPendingApproval(element) ? 'Yes' : 'No' }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="mat-header-cell">
            Actions
          </th>
          <td mat-cell *matCellDef="let element" class="pointer">
            <button
              mat-icon-button
              [matMenuTriggerFor]="detailsMenu"
              #detailsMenuTrigger="matMenuTrigger"
              (click)="openDetailsMenu(detailsMenuTrigger)">
              <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu
              #detailsMenu="matMenu"
              (mouseleave)="closeMenu(detailsMenuTrigger)">
              <button
                mat-menu-item
                (click)="openViewIncentiveProgramDialog(element)">
                <mat-icon class="icon-color">visibility</mat-icon>
                View
              </button>

              <button
                mat-menu-item
                (click)="openEditIncentiveProgramDialog(element)"
                [matTooltip]="hasPendingApproval(element) ? 'A submission is already pending approval' : ''"
                [disabled]="isPastEffectiveDate(element.effectiveDate) || hasPendingApproval(element)">
                <mat-icon class="icon-color">edit_note</mat-icon>
                Edit
              </button>

              <button
                mat-menu-item
                (click)="openDeleteDialog(element)"
                [matTooltip]="hasPendingApproval(element) ? 'A submission is already pending approval' : ''"
                [disabled]="isPastEffectiveDate(element.effectiveDate) || hasPendingApproval(element)">
                <mat-icon class="icon-color">delete</mat-icon>
                Delete
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <h3 class="align-center" *ngIf="dataSource.data.length === 0">
      <br />
      No Records Found.
    </h3>

  </div>



</div>


<ng-template #noAccess>
  <div class="container-fluid text-center mt-4">
    <div class="row justify-content-center align-items-center">
      <div class="col-auto">
                <p class="mb-3">Access Denied: You do not have the required permissions to view this content.</p>
      </div>
    </div>
  </div>
</ng-template>
